import React, {useState, useRef, useEffect} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { FilterMatchMode } from 'primereact/api';
import './DocumentsDashboard.scss';
import { Fieldset } from "primereact/fieldset";
import ReferencesDialog from "./ReferencesDialog";
import {addUnitFile, openFile} from "../../Integration";
import { FileUpload } from "primereact/fileupload";
const urlApi = process.env.REACT_APP_API_KEY


const DocumentsDashboard = ({ formData,  handleInputChange, parseDate, handleDateChange, files, unit, tienePermiso }) => {
    const toast = useRef(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        documento: { value: null, matchMode: FilterMatchMode.CONTAINS },
        estatus: { value: null, matchMode: FilterMatchMode.EQUALS },
    });
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [showReferences, setShowReferences] = useState(false);
    const [visible, setVisible] = useState(false);
    const initialDocumentState = {
        nombre: null,
        fecha: null,
        vencimiento: null,
        renovado: true,
        archivo: null,
        idTipoDocumento: null,
        idUnidad: unit || formData.ID,
    };
    const [document, setDocument] = useState(initialDocumentState);

    useEffect(() => {
        setDocument({
            ...initialDocumentState,
            idUnidad: unit || formData.ID,
        });
    }, [formData.ID])

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const handleChange = (field, value) => {
        setDocument(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const dateChange = (fieldName) => (e) => {
        setDocument(prevService => ({
            ...prevService,
            [fieldName]: e.value ? e.value.toISOString().split('T')[0] : null
        }));
    };

    const uploaded = async (e) => {
        const response = JSON.parse(e.xhr.response);
        handleChange('archivo', response.fileName);
    };

    const beforeUpload = (request) => {
        const token = sessionStorage.getItem("token");
        request.xhr.setRequestHeader('Authorization', `${token}`)
        return request;
    }

    const renderHeader = () => {
        return (
            <div className="table-header">
                <h2 className="header-title">
                    <i className="pi pi-file-o"></i>
                    Documentos Generales
                </h2>
                <div className="header-actions">
                    <span className="p-input-icon-left search-input">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Buscar documentos..."
                        />
                    </span>
                    {/*<Button
                        icon="pi pi-plus"
                        label="Agregar"
                        className="p-button-success"
                        onClick={() => toast.current.show({severity:'info', summary: 'Información', detail: 'Funcionalidad de agregar documento', life: 3000})}
                    />*/}
                </div>
            </div>
        );
    };

    const statusBodyTemplate = (rowData) => {
        const getSeverity = (status) => {
            switch (status) {
                case 'ACTIVO': return 'success';
                case 'SIN REGISTRO': return 'warning';
                case 'VENCIDO': return 'danger';
                default: return 'info';
            }
        };

        return (
            <Tag
                value={rowData.estatus.toUpperCase()}
                className="p-tag-subtle"
                severity={getSeverity(rowData.estatus)}
                icon={rowData.estatus === 'ACTIVO' ? 'pi pi-check' : rowData.estatus === 'SIN REGISTRO' ? 'pi pi-clock' : 'pi pi-times'}
            />
        );
    };

    const dateBodyTemplate = (rowData, field) => {
        const date = rowData[field.field];
        if (!date) return <span className="text-muted">No definido</span>;
        const dateN = new Date(date);
        return dateN.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    };

    const saveDocument = async () => {
        setVisible(false);
        await addUnitFile(document);
        setDocument(initialDocumentState);
    }

    const frequencyBodyTemplate = (rowData) => {
        if (!rowData.frecuencia) return <span className="text-muted">-</span>;
        return (
            <Badge
                value={`${rowData.frecuencia} meses`}
                severity="info"
            />
        );
    };

    const referencesBodyTemplate = (rowData) => {
        if (!rowData.referencias || rowData.referencias.length === 0) {
            return <span className="text-muted">Sin referencias</span>;
        }

        return (
            <div className="references-preview">
                <Button
                    icon="pi pi-eye"
                    label={`Ver ${rowData.referencias.length} referencias`}
                    className="p-button-text p-button-sm"
                    onClick={() => {
                        setSelectedDocument(rowData);
                        setShowReferences(true);
                    }}
                />
            </div>
        );
    };

    const actionsBodyTemplate = (rowData) => {
        return (
            <div className="action-buttons">
                {formData && (
                    <Button
                        icon="pi pi-plus"
                        tooltip="Nuevo"
                        rounded outlined
                        disabled={!formData.ID && !unit}
                        onClick={() => {
                            setVisible(true);
                            handleChange('idTipoDocumento', rowData.id);
                        }}
                    />
                )}

               {/* <Button
                    icon="pi pi-eye"
                    rounded text severity="help"
                    tooltip="Ver detalles"
                    onClick={() => toast.current.show({severity:'info', summary: 'Información', detail: `Viendo ${rowData.documento}`, life: 3000})}
                />
                <Button
                    icon="pi pi-trash"
                    rounded text severity="warning"
                    className="p-button-text p-button-danger p-button-sm"
                    tooltip="Eliminar"
                    onClick={() => toast.current.show({severity:'warn', summary: 'Advertencia', detail: `¿Eliminar ${rowData.documento}?`, life: 3000})}
                />*/}
            </div>
        );
    };

    const documentBodyTemplate = (rowData) => {
        const getDocumentIcon = (documento) => {
            if (documento.includes('FACTURA')) return 'pi pi-receipt';
            if (documento.includes('PÓLIZA')) return 'pi pi-shield';
            return 'pi pi-file';
        };

        return (
            <div className="document-cell">
                <i className={`${getDocumentIcon(rowData.documento)} document-icon`}></i>
                <span className="document-name">{rowData.documento}</span>
            </div>
        );
    };

    const legendTemplate = (
        <div className="flex align-items-center justify-content-between w-full">
            <div>
                <h3 className="m-0 text-lg font-semibold text-color">Expediente</h3>
                <p className="m-0 mt-1 text-sm text-color-secondary">Sistema de Gestión Vehicular</p>
            </div>
        </div>
    );

    const dialogFooter = (
        <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={() => setVisible(false)} className="p-button-text"/>
            <Button label="Aceptar" icon="pi pi-check" onClick={saveDocument} autoFocus/>
        </div>
    )

    return (
        <Fieldset legend={legendTemplate} toggleable>
            <Toast ref={toast}/>
            <ConfirmDialog/>
            <div className="documents-dashboard">
                <Card className="documents-card">
                    <DataTable
                        value={files}
                        className="documents-table"
                        header={renderHeader()}
                        filters={filters}
                        globalFilterFields={['documento', 'estatus', 'referencia']}
                        emptyMessage="No se encontraron documentos"
                        responsiveLayout="scroll"
                        stripedRows
                        showGridlines
                    >
                        <Column
                            field="estatus"
                            header="Estado"
                            body={statusBodyTemplate}
                            sortable
                            style={{minWidth: '120px'}}
                        />
                        <Column
                            field="fecha"
                            header="Fecha"
                            body={(rowData) => dateBodyTemplate(rowData, {field: 'fecha'})}
                            sortable
                            style={{minWidth: '120px'}}
                        />
                        <Column
                            field="documento"
                            header="Documento"
                            body={documentBodyTemplate}
                            sortable
                            style={{minWidth: '250px'}}
                        />
                        <Column
                            field="frecuencia"
                            header="Frecuencia"
                            body={frequencyBodyTemplate}
                            sortable
                            style={{minWidth: '120px'}}
                        />
                        <Column
                            field="vencimiento"
                            header="Vencimiento"
                            body={(rowData) => dateBodyTemplate(rowData, {field: 'vencimiento'})}
                            sortable
                            style={{minWidth: '120px'}}
                        />
                        <Column
                            field="referencia"
                            header="Referencias"
                            body={referencesBodyTemplate}
                            style={{minWidth: '180px'}}
                        />
                        {tienePermiso && (
                            <Column
                                header="Acciones"
                                body={actionsBodyTemplate}
                                style={{minWidth: '150px'}}
                            />
                        )}

                    </DataTable>
                </Card>
                <ReferencesDialog
                    selectedDocument={selectedDocument}
                    showReferences={showReferences}
                    setShowReferences={setShowReferences}
                    onFileOpen={(reference) => {
                        openFile(unit, reference.archivo)
                    }}
                />

                <Dialog
                    header={
                        <div className="dialog-header-custom">
                            <i className="pi pi-file-edit mr-1"></i>
                            <span>Documento</span>
                        </div>
                    }
                    visible={visible}
                    style={{ width: '50vw' }}
                    modal
                    onHide={() => setVisible(false)}
                    footer={dialogFooter}
                    breakpoints={{ '960px': '75vw', '640px': '95vw' }}
                >
                    <div className="document-dialog-content">
                        {/* Información del documento */}
                        <div className="info-section">
                            <div className="section-header flex align-items-center">
                                <i className="pi pi-info-circle mr-2"></i>
                                <h3>Información del documento</h3>
                            </div>

                            <div className="form-grid">
                                <div className="field">
                                    <label htmlFor="nombre">Nombre de Archivo</label>
                                    <InputText
                                        id="nombre"
                                        value={document.nombre}
                                        onChange={(e) => handleChange('nombre', e.target.value)}
                                        className="w-full"
                                    />
                                </div>

                                <div className="field">
                                    <label htmlFor="fecha">Fecha</label>
                                    <Calendar
                                        id="fecha"
                                        value={parseDate(document?.fecha)}
                                        onChange={dateChange('fecha')}
                                        dateFormat="dd/mm/yy"
                                        showIcon
                                        className="w-full"
                                    />
                                </div>

                                <div className="field">
                                    <label htmlFor="vencimiento">Vencimiento</label>
                                    <Calendar
                                        id="vencimiento"
                                        value={parseDate(document?.vencimiento)}
                                        onChange={dateChange('vencimiento')}
                                        dateFormat="dd/mm/yy"
                                        showIcon
                                        className="w-full"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Upload de archivo */}
                        <div className="upload-section">
                            <div className="section-header flex align-items-center">
                                <i className="pi pi-upload mr-2"></i>
                                <h3>Subir archivo</h3>
                            </div>

                            <FileUpload
                                name="file"
                                url={`${urlApi}/maintenance/uploadFile?unit=${unit || formData.ID}`}
                                accept="image/*,application/pdf"
                                maxFileSize={1000000}
                                chooseLabel="Seleccionar archivo"
                                uploadLabel="Subir"
                                cancelLabel="Cancelar"
                                onBeforeSend={beforeUpload}
                                onUpload={uploaded}
                                emptyTemplate={
                                    <div className="upload-empty">
                                        <i className="pi pi-cloud-upload"></i>
                                        <p>Arrastra y suelta archivos aquí</p>
                                        <span>o haz clic en "Seleccionar archivo"</span>
                                    </div>
                                }
                            />
                        </div>
                    </div>
                </Dialog>
            </div>
        </Fieldset>

    );
};

export default DocumentsDashboard;